<template>
  <div>
    <Campaign />
  </div>
</template>
<script>
import Campaign from "./components/Campaign";
export default {
  components: {
    Campaign,
  },
};
</script>
